(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewtech-collection-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.sewtechCollectionVideoBound) {
    window.sewtechCollectionVideoBound = true;
    let activeVideoButton = null;
    let activeVideoPlayer = null;
    let activeVideoRequest = 0;
    let youtubeApiPromise = null;

    const loadSewtechYoutubeApi = () => {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (youtubeApiPromise) return youtubeApiPromise;

      youtubeApiPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          document.head.appendChild(script);
        }

        let attempts = 0;
        const waitForApi = () => {
          if (window.YT?.Player) {
            resolve(window.YT);
            return;
          }
          attempts += 1;
          if (attempts >= 150) {
            reject(new Error('YouTube player API timed out'));
            return;
          }
          window.setTimeout(waitForApi, 100);
        };
        waitForApi();
      }).catch((error) => {
        youtubeApiPromise = null;
        throw error;
      });

      return youtubeApiPromise;
    };

    const resetSewtechVideoSurface = (modal) => {
      const ratio = modal?.querySelector('.sewtech-collection-hero__video-ratio');
      const layout = modal?.querySelector('.sewtech-collection-hero__video-layout');
      const playlist = modal?.querySelector('.sewtech-collection-hero__video-playlist');
      const playlistTitle = modal?.querySelector('.sewtech-collection-hero__video-playlist-title');
      const playlistCount = modal?.querySelector('.sewtech-collection-hero__video-playlist-count');
      const playlistItems = modal?.querySelector('.sewtech-collection-hero__video-playlist-items');

      if (ratio) {
        const playerHost = document.createElement('div');
        playerHost.className = 'sewtech-collection-hero__video-player-host';
        ratio.replaceChildren(playerHost);
      }
      layout?.classList.remove('is-playlist');
      if (playlist) playlist.hidden = true;
      if (playlistTitle) playlistTitle.textContent = '';
      if (playlistCount) playlistCount.textContent = '';
      playlistItems?.replaceChildren();
    };

    const setActiveSewtechPlaylistItem = (modal, index) => {
      const items = modal?.querySelectorAll('.sewtech-collection-hero__video-playlist-item');
      items?.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    };

    const renderSewtechPlaylist = (modal, player, videoTitle, requestId, attempts = 0) => {
      if (
        requestId !== activeVideoRequest ||
        modal?.getAttribute('aria-hidden') !== 'false' ||
        player !== activeVideoPlayer
      ) {
        return;
      }

      const videoIds = player.getPlaylist?.() || [];
      if (!videoIds.length && attempts < 20) {
        window.setTimeout(
          () => renderSewtechPlaylist(modal, player, videoTitle, requestId, attempts + 1),
          250,
        );
        return;
      }

      const playlist = modal.querySelector('.sewtech-collection-hero__video-playlist');
      const playlistTitle = modal.querySelector('.sewtech-collection-hero__video-playlist-title');
      const playlistCount = modal.querySelector('.sewtech-collection-hero__video-playlist-count');
      const playlistItems = modal.querySelector('.sewtech-collection-hero__video-playlist-items');
      if (!playlist || !playlistTitle || !playlistCount || !playlistItems || !videoIds.length) return;

      playlistTitle.textContent = videoTitle;
      playlistCount.textContent = String(videoIds.length);
      const fragment = document.createDocumentFragment();

      videoIds.forEach((youtubeId, index) => {
        const item = document.createElement('button');
        const thumbnail = document.createElement('img');
        const number = document.createElement('span');

        item.type = 'button';
        item.className = 'sewtech-collection-hero__video-playlist-item';
        item.dataset.sewtechPlaylistIndex = String(index);
        item.setAttribute('role', 'listitem');
        item.setAttribute('aria-label', `${videoTitle} ${index + 1}`);

        thumbnail.src = `https://i.ytimg.com/vi/${encodeURIComponent(youtubeId)}/mqdefault.jpg`;
        thumbnail.alt = '';
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';

        number.className = 'sewtech-collection-hero__video-playlist-number';
        number.textContent = String(index + 1);

        item.append(thumbnail, number);
        fragment.appendChild(item);
      });

      playlistItems.replaceChildren(fragment);
      playlist.hidden = false;
      setActiveSewtechPlaylistItem(modal, player.getPlaylistIndex?.() || 0);
    };

    const createSewtechVideoFallback = (modal, videoId, youtubeType, videoTitle) => {
      const ratio = modal?.querySelector('.sewtech-collection-hero__video-ratio');
      if (!ratio) return;

      const frame = document.createElement('iframe');
      frame.title = videoTitle;
      frame.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.src =
        youtubeType === 'playlist'
          ? `https://www.youtube.com/embed?listType=playlist&list=${encodeURIComponent(videoId)}&autoplay=1&rel=0`
          : `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
      ratio.replaceChildren(frame);
    };

    const openSewtechVideo = (modal, videoId, youtubeType, videoTitle) => {
      const requestId = ++activeVideoRequest;
      const layout = modal.querySelector('.sewtech-collection-hero__video-layout');
      const playlist = modal.querySelector('.sewtech-collection-hero__video-playlist');
      resetSewtechVideoSurface(modal);

      if (youtubeType === 'playlist') {
        layout?.classList.add('is-playlist');
        if (playlist) playlist.hidden = false;
      }

      modal.setAttribute('aria-label', videoTitle);
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sewtech-video-open');
      modal.querySelector('.sewtech-collection-hero__video-close')?.focus();

      loadSewtechYoutubeApi()
        .then((YT) => {
          if (requestId !== activeVideoRequest || modal.getAttribute('aria-hidden') !== 'false') return;
          const playerHost = modal.querySelector('.sewtech-collection-hero__video-player-host');
          if (!playerHost) return;

          const playerConfig = {
            width: '100%',
            height: '100%',
            playerVars: {
              autoplay: 1,
              playsinline: 1,
              rel: 0,
            },
            events: {
              onReady: (playerEvent) => {
                if (requestId !== activeVideoRequest) return;
                playerEvent.target.getIframe?.().setAttribute('title', videoTitle);
                if (youtubeType === 'playlist') {
                  renderSewtechPlaylist(modal, playerEvent.target, videoTitle, requestId);
                }
              },
              onStateChange: (playerEvent) => {
                if (youtubeType !== 'playlist' || requestId !== activeVideoRequest) return;
                const currentIndex = playerEvent.target.getPlaylistIndex?.();
                if (Number.isInteger(currentIndex) && currentIndex >= 0) {
                  setActiveSewtechPlaylistItem(modal, currentIndex);
                }
              },
            },
          };

          if (youtubeType === 'playlist') {
            playerConfig.playerVars.listType = 'playlist';
            playerConfig.playerVars.list = videoId;
          } else {
            playerConfig.videoId = videoId;
          }

          activeVideoPlayer = new YT.Player(playerHost, playerConfig);
        })
        .catch(() => {
          if (requestId !== activeVideoRequest || modal.getAttribute('aria-hidden') !== 'false') return;
          resetSewtechVideoSurface(modal);
          createSewtechVideoFallback(modal, videoId, youtubeType, videoTitle);
        });
    };

    const closeSewtechVideo = (modal) => {
      if (!modal) return;
      activeVideoRequest += 1;
      try {
        activeVideoPlayer?.destroy();
      } catch (error) {
        // The player may already have been removed by the browser.
      }
      activeVideoPlayer = null;
      resetSewtechVideoSurface(modal);
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sewtech-video-open');
      if (activeVideoButton) {
        activeVideoButton.setAttribute('aria-pressed', 'false');
        activeVideoButton.focus();
        activeVideoButton = null;
      }
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const playlistItem = event.target.closest('.sewtech-collection-hero__video-playlist-item');
      if (playlistItem) {
        const index = Number.parseInt(playlistItem.dataset.sewtechPlaylistIndex || '', 10);
        if (Number.isInteger(index) && activeVideoPlayer?.playVideoAt) {
          activeVideoPlayer.playVideoAt(index);
          setActiveSewtechPlaylistItem(
            playlistItem.closest('.sewtech-collection-hero__video-modal'),
            index,
          );
        }
        return;
      }

      const videoButton = event.target.closest('.sewtech-collection-hero__video-button');
      if (videoButton) {
        const hero = videoButton.closest('.sewtech-collection-hero');
        const modal = hero?.querySelector('.sewtech-collection-hero__video-modal');
        const videoId = videoButton.dataset.sewtechYoutubeId;
        const youtubeType = videoButton.dataset.sewtechYoutubeType === 'playlist' ? 'playlist' : 'video';
        const videoTitle = videoButton.dataset.sewtechVideoTitle || 'YouTube video player';
        if (!modal || !videoId) return;

        if (activeVideoButton && activeVideoButton !== videoButton) {
          activeVideoButton.setAttribute('aria-pressed', 'false');
        }
        activeVideoButton = videoButton;
        videoButton.setAttribute('aria-pressed', 'true');
        openSewtechVideo(modal, videoId, youtubeType, videoTitle);
        return;
      }

      const closeButton = event.target.closest('.sewtech-collection-hero__video-close');
      if (closeButton) {
        closeSewtechVideo(closeButton.closest('.sewtech-collection-hero__video-modal'));
        return;
      }

      if (event.target.classList.contains('sewtech-collection-hero__video-modal')) {
        closeSewtechVideo(event.target);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openModal = document.querySelector(
        ".sewtech-collection-hero__video-modal[aria-hidden='false']",
      );
      closeSewtechVideo(openModal);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewtech-open-day"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('#OpenDayContact');
    const card = root.querySelector('#od-rsvp');
    const floating = root.querySelector('[data-floating-rsvp]');
    const pendingKey = 'sewtech-open-day-pending:' + root.dataset.eventId;
    const storage = {get(key) {try {return sessionStorage.getItem(key);} catch {return null;}},set(key,value) {try {sessionStorage.setItem(key,value);} catch {}},remove(key) {try {sessionStorage.removeItem(key);} catch {}}};
    const url = new URL(window.location.href);
    if (form) {
      const returnInput = form.querySelector('[name="return_to"]');
      if (returnInput) {
        const params = new URLSearchParams();
        ['view','preview_theme_id','_ab','_fd','_sc'].forEach((key) => {if (url.searchParams.has(key)) params.set(key,url.searchParams.get(key));});
        returnInput.value = url.pathname + (params.size ? '?' + params.toString() : '') + '#od-rsvp';
      }
      root.querySelectorAll('[data-source]').forEach((input) => {input.value = (url.searchParams.get(input.dataset.source) || '').slice(0,180);});
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        storage.set(pendingKey, JSON.stringify({id:window.crypto?.randomUUID?.() || String(Date.now()),at:Date.now()}));
      });
    }
    const success = root.querySelector('[data-rsvp-success]');
    const successSummary = root.querySelector('[data-rsvp-success-summary]');
    if (success) {
      let pending;
      try {pending = JSON.parse(storage.get(pendingKey) || 'null');} catch {}
      storage.remove(pendingKey);
      if (pending && Date.now() - pending.at < 30 * 60 * 1000 && root.dataset.tracking === 'true') {
        const event = {event:'sewtech_open_day_rsvp',event_id:pending.id,event_name:root.dataset.eventId};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
        window.dispatchEvent(new CustomEvent('sewtech:open-day-rsvp',{detail:event}));
      }
      card.scrollIntoView({block:'start',behavior:'instant'});
      const restoreSuccessFocus = () => successSummary?.focus({preventScroll:true});
      const closeSuccess = () => {
        if (typeof success.close === 'function' && success.open) success.close();
        else success.removeAttribute('open');
        restoreSuccessFocus();
      };
      success.querySelectorAll('[data-close-success]').forEach((button) => button.addEventListener('click',closeSuccess));
      success.addEventListener('close',restoreSuccessFocus);
      success.addEventListener('click',(event) => {
        if (event.target !== success) return;
        const box = success.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeSuccess();
      });
      success.removeAttribute('open');
      if (typeof success.showModal === 'function') success.showModal();
      else success.setAttribute('open','');
    }
    let cardVisible = false;
    let heroActionVisible = false;
    let videosVisible = false;
    const heroAction = root.querySelector('.od-hero-actions .od-button');
    const videos = root.querySelector('.od-videos');
    const machineActions = new Set(root.querySelectorAll('.od-machine-actions'));
    const visibleMachineActions = new Set();
    const updateFloating = () => {
      if (!floating) return;
      const inputFocused = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
      const ended = Number.isFinite(Date.parse(root.dataset.eventEnd)) && Date.now() >= Date.parse(root.dataset.eventEnd);
      floating.toggleAttribute('data-hidden', cardVisible || heroActionVisible || videosVisible || visibleMachineActions.size > 0 || inputFocused || Boolean(success) || ended);
    };
    if (floating && card) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === card) cardVisible = entry.isIntersecting;
          if (entry.target === heroAction) heroActionVisible = entry.isIntersecting;
          if (entry.target === videos) videosVisible = entry.isIntersecting;
          if (machineActions.has(entry.target)) {
            if (entry.isIntersecting) visibleMachineActions.add(entry.target);
            else visibleMachineActions.delete(entry.target);
          }
        });
        updateFloating();
      },{threshold:0});
      observer.observe(card);
      if (heroAction) observer.observe(heroAction);
      if (videos) observer.observe(videos);
      machineActions.forEach(action=>observer.observe(action));
      root.addEventListener('focusin',updateFloating);
      root.addEventListener('focusout',() => requestAnimationFrame(updateFloating));
      updateFloating();
    }
    root.querySelectorAll('a[href="#od-rsvp"]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      card.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      card.focus({preventScroll:true});
      history.replaceState(null,'','#od-rsvp');
    }));
    root.querySelectorAll('[data-youtube-id]').forEach((button) => button.addEventListener('click',() => {
      const id = button.dataset.youtubeId;
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = button.dataset.videoTitle;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      button.replaceWith(iframe);
    }));
    root.querySelector('[data-show-videos]')?.addEventListener('click',(event) => {
      root.querySelector('.od-videos').setAttribute('data-expanded','');
      event.currentTarget.setAttribute('aria-expanded','true');
      event.currentTarget.hidden = true;
    });
    root.querySelectorAll('[data-calendar]').forEach((button) => button.addEventListener('click', () => {
      const iso = (value) => new Date(value).toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
      const escape = (value) => value.replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
      const lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//SEWTECH//Open Day//EN','BEGIN:VEVENT','UID:' + root.dataset.eventId + '@sewtechstore.com','DTSTAMP:' + iso(Date.now()),'DTSTART:' + iso(root.dataset.eventStart),'DTEND:' + iso(root.dataset.eventEnd),'SUMMARY:' + escape(root.dataset.eventTitle),'LOCATION:' + escape(root.dataset.eventAddress),'DESCRIPTION:Live ST-1501 and ST-1201 demonstrations with Garcia. English and Spanish.','END:VEVENT','END:VCALENDAR'];
      const blob = new Blob([lines.join('\r\n') + '\r\n'],{type:'text/calendar;charset=utf-8'});
      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl; link.download = 'sewtech-open-day-houston.ics'; link.click();
      setTimeout(() => URL.revokeObjectURL(downloadUrl),2000);
    }));
  };
  document.querySelectorAll('[data-open-day]').forEach(initialize);
  document.addEventListener('shopify:section:load',(event) => initialize(event.target.querySelector('[data-open-day]')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewtech-partners-review"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sewtech-partners-review')) {
    class SewtechPartnersReview extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.region = 'all';
        this.service = 'all';
        this.cards = [...this.querySelectorAll('[data-partner-card]')];
        this.buttons = [...this.querySelectorAll('.spv-regions button[data-region]')];
        this.country = this.querySelector('[data-partner-country]');
        this.serviceButtons = [...this.querySelectorAll('[data-service]')];
        this.serviceAll = this.querySelector('[data-service-all]');
        this.serviceAll.hidden = false;
        this.serviceButtons.forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            this.service = this.service === button.dataset.service ? 'all' : button.dataset.service;
            this.filterCards();
          });
        });
        this.serviceAll.addEventListener('click', () => { this.service = 'all'; this.filterCards(); });
        this.empty = this.querySelector('[data-partners-empty]');
        this.querySelector('[data-partner-filters]').hidden = false;
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.region = button.dataset.region;
          this.country.value = 'all';
          this.filterCards();
        }));
        this.country.addEventListener('change', () => this.filterCards());
        this.querySelector('[data-reset-partners]').addEventListener('click', () => {
          this.service = 'all';
          this.region = 'all';
          this.country.value = 'all';
          this.filterCards();
          this.buttons[0].focus();
        });
        this.addEventListener('shopify:block:select', event => {
          if (!event.target.matches('[data-partner-card]')) return;
          this.service = 'all';
          this.region = 'all';
          this.country.value = 'all';
          this.filterCards();
          event.target.querySelector('details')?.setAttribute('open', '');
        });
        this.querySelectorAll('[data-spv-whatsapp-message]').forEach(trigger => {
          trigger.addEventListener('click', () => {
            const input = document.getElementById('wa-input-msg');
            if (!input) return;
            if (!input.value.trim() || input.value === input.dataset.spvPartnerPrefill) {
              input.value = trigger.dataset.spvWhatsappMessage;
              input.dataset.spvPartnerPrefill = input.value;
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
        });
        this.filterCards();
      }
      filterCards() {
        let visible = 0;
        this.cards.forEach(card => {
          const matches = (this.region === 'all' || card.dataset.region === this.region) && (this.country.value === 'all' || card.dataset.country === this.country.value) && (this.service === 'all' || card.dataset.services.trim().split(/\s+/).includes(this.service));
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        this.buttons.forEach(button => {
          const active = button.dataset.region === this.region;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        [...this.country.options].forEach(option => {
          option.disabled = option.value !== 'all' && this.region !== 'all' && !this.cards.some(card => card.dataset.country === option.value && card.dataset.region === this.region);
        });
        this.serviceButtons.forEach(button => {
          const active = this.service === button.dataset.service;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.serviceAll.classList.toggle('is-active', this.service === 'all');
        this.serviceAll.setAttribute('aria-pressed', String(this.service === 'all'));
        this.empty.hidden = visible !== 0;
      }
    }
    customElements.define('sewtech-partners-review', SewtechPartnersReview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewtech-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sewtech-partners')) {
    class SewtechPartners extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.region = 'all';
        this.cards = [...this.querySelectorAll('[data-partner-card]')];
        this.buttons = [...this.querySelectorAll('.sp-regions button[data-region]')];
        this.country = this.querySelector('[data-partner-country]');
        this.empty = this.querySelector('[data-partners-empty]');
        this.querySelector('[data-partner-filters]').hidden = false;
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.region = button.dataset.region;
          this.country.value = 'all';
          this.filterCards();
        }));
        this.country.addEventListener('change', () => this.filterCards());
        this.querySelector('[data-reset-partners]').addEventListener('click', () => {
          this.region = 'all';
          this.country.value = 'all';
          this.filterCards();
          this.buttons[0].focus();
        });
        this.addEventListener('shopify:block:select', event => {
          this.region = 'all';
          this.country.value = 'all';
          this.filterCards();
          event.target.querySelector('details')?.setAttribute('open', '');
        });
        this.querySelectorAll('[data-sp-whatsapp-message]').forEach(trigger => {
          trigger.addEventListener('click', () => {
            const input = document.getElementById('wa-input-msg');
            if (!input) return;
            if (!input.value.trim() || input.value === input.dataset.spPartnerPrefill) {
              input.value = trigger.dataset.spWhatsappMessage;
              input.dataset.spPartnerPrefill = input.value;
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
        });
        this.filterCards();
      }
      filterCards() {
        let visible = 0;
        this.cards.forEach(card => {
          const matches = (this.region === 'all' || card.dataset.region === this.region) && (this.country.value === 'all' || card.dataset.country === this.country.value);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        this.buttons.forEach(button => {
          const active = button.dataset.region === this.region;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        [...this.country.options].forEach(option => {
          option.disabled = option.value !== 'all' && this.region !== 'all' && !this.cards.some(card => card.dataset.country === option.value && card.dataset.region === this.region);
        });
        this.empty.hidden = visible !== 0;
      }
    }
    customElements.define('sewtech-partners', SewtechPartners);
  }

  } catch(e) { console.error(e); }
})();
})();
